import { initI18n } from '@quadralize/i18n'
import { createSentryErrorHandlers } from '@quadralize/sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Providers } from '@/app/providers'
import { router } from '@/app/router'
import { initSentry } from '@/config/sentry'
import play from '@/locales/pt-BR/play'

import '@/styles/index.css'

initSentry()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Failed to find the root element')
}

const appRootElement = rootElement

async function bootstrap(): Promise<void> {
  await initI18n({ play })

  createRoot(appRootElement, createSentryErrorHandlers()).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  )
}

void bootstrap()
